import { useCallback, useMemo } from "react";

import {
  DateTimeFormat,
  DatetimeInput,
  formatInPreferredTimezone,
  FormatInTimezoneOptions,
  resolvePreferredTimezone,
} from "helpers/dateTimeHelper";
import usePermissions from "hooks/usePermissions";

export function useFormatPreferredDatetime(defaultFormat = DateTimeFormat.fullDateTimeFormat) {
  const { permissions, parsedPermissions } = usePermissions();

  const preferredTimezone = useMemo(
    () => parsedPermissions?.preferred_timezone ?? resolvePreferredTimezone(),
    [permissions, parsedPermissions?.preferred_timezone],
  );

  const formatPreferredDatetime = useCallback(
    (value: DatetimeInput, format?: string, options?: FormatInTimezoneOptions) =>
      formatInPreferredTimezone(value, format ?? defaultFormat, {
        ...options,
        timezone: options?.timezone ?? preferredTimezone,
      }),
    [preferredTimezone, defaultFormat],
  );

  return { preferredTimezone, formatPreferredDatetime };
}
